import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IMAGE_CONFIG } from '@angular/common';
import { GlobalErrorHandler } from './core/handlers/global-error.handler';
import { SnackbarService } from './shared/services/snackBarService.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LayoutModule } from './layout/layout.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { GlobalService } from './shared/services/global.service';
import { NgChartsModule } from 'ng2-charts';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule, NativeDateAdapter } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LoadingIndicatorModule } from './loading-indicator/loading-indicator.module';
import { RouterModule } from '@angular/router';
import { PendingInterceptorModule } from './loading-indicator/pending-interceptor.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';

export function jwtOptionsFactory(globalService: GlobalService) {
  return {
    tokenGetter: () => {
      return globalService.user.accessToken;
    },
  };
}

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        // SharedModule,
        RouterModule,
        LoadingIndicatorModule,
        MatSnackBarModule,
        NgChartsModule,
        MatIconModule,
        // Layout Module (Sidenav, Toolbar, Quickpanel, Content)
        LayoutModule,
        // Displays Loading Bar when a Route Request or HTTP Request is pending
        PendingInterceptorModule,
        MatDatepickerModule,
        MatNativeDateModule, // Ensure this is imported
        NgIdleKeepaliveModule.forRoot(),
        JwtModule.forRoot({
            jwtOptionsProvider: {
                provide: JWT_OPTIONS,
                useFactory: jwtOptionsFactory,
                deps: [GlobalService],
            },
        })], providers: [
        provideAnimations(),
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        {
            provide: IMAGE_CONFIG,
            useValue: {
                disableImageSizeWarning: true,
                disableImageResolutionWarning: true,
            },
        },
        { provide: DateAdapter, useClass: NativeDateAdapter },
        MatNativeDateModule,
        // { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
